module.exports = __webpack_public_path__ + "img/about.379c11f.png";